export const formatGatewayFields = (trunkGateway) => [
  {
    label: "Gateway Name",
    value: trunkGateway.name,
    bolded: true,
  },
  {
    label: "Gateway Brand",
    value: trunkGateway.brand,
  },
  {
    label: "Proxy Server",
    value: trunkGateway.proxyServer,
    monospace: true,
  },
  {
    label: "License ID",
    value: trunkGateway.licenseId,
  },
  {
    label: "Login ID",
    value: trunkGateway.loginId,
  },
  {
    label: "Password",
    value: trunkGateway.password,
  },
];

export const formatSubscriberDetails = (subscriber) => [
  {
    label: "First name",
    value: subscriber.firstName,
  },
  {
    label: "Last name",
    value: subscriber.lastName,
  },
  {
    label: "Email",
    value: subscriber.email,
  },
  {
    label: "Service Country",
    value: subscriber.serviceCountry,
  },
  {
    label: "Brand ID",
    value: subscriber.brandId,
  },
];
